export default "__VITE_ASSET__7JE6NkXF__"